<fgb-page-header [pageTitle]="'offers.banner.title'" [showBalance]="false" [showBanner]="false"></fgb-page-header>

<div class="container">
  <div class="d-flex page-padding">
    <div class="back-button">
      <ng-container *ifScreenSize="screenSize.Desktop">
        <div class="py-3">
          <div class="campaign-back-button bg-glass-dark cursor-pointer" (click)="goBack()">
            <span class="material-icons align-middle text-white">arrow_back_ios_new</span>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- Image -->
    <div class="loyalty-details-image rounded overflow-hidden p-0">
      <img
        [campaignImage]="currentCampaign?.CampaignId"
        alt="campaign details"
        class="logo"
        [style.opacity]="currentCampaign?.Claimed ? 0.5 : 1"
      />
    </div>
    <div class="back-button icon-placement">
      <ng-container *ngIf="!currentCampaign?.Claimed && !isDisplayUntilDateExpired">
        <span class="back-button icon material-icons text-white text-end ms-3"> lock </span>
      </ng-container>
    </div>
  </div>
  <!-- Name -->
  <div class="text-center font-size-14 fw-bold mt-3 text-white">{{ currentCampaign?.CampaignName }}</div>
  <!-- Claimed -->
  <ng-container *ngIf="currentCampaign?.Claimed && currentCampaign?.VoucherRedemptions >= 1">
    <div class="text-center font-size-12 fw-bold text-white mt-2">{{ 'offer.claimed' | translate }}</div>
  </ng-container>
  <!-- Expiry -->
  <ng-container *ngIf="!currentCampaign?.Claimed">
    <div class="font-size-12 text-white text-center pt-lg-2 pt-0">
      <ng-container *ngIf="!(isDateExpired && isDisplayUntilDateExpired); else expired">
        {{ 'offer.expiry' | translate }} {{ currentCampaign?.ExpiryDate | UtcToLocaltimePipe: dateOption.NgbDateFormat }}
      </ng-container>
      <ng-template #expired>
        <span class="fw-bold">
          {{ 'offer.expired' | translate }}
        </span>
      </ng-template>
    </div>
  </ng-container>
  <!-- Barcode -->
  <ng-container *ngIf="currentCampaign?.VoucherQuantity >= 1 && !isDisplayUntilDateExpired && !isDateExpired">
    <ng-container *ngIf="!currentCampaign?.Barcode">
      <div
        class="bg-secondary text-white text-center border rounded mt-3 scan-barcode-text d-flex align-items-center justify-content-center"
      >
        <span class="font-size-12">{{ 'offer.scan.barcode.text' | translate }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="currentCampaign?.Barcode">
      <div class="barcode-container d-flex justify-content-center py-3">
        <div class="qr">
          <qrcode [qrdata]="currentCampaign?.Barcode" [width]="127" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <hr class="border-top border-disabled opacity-100 my-3" />
  <!-- Description -->
  <label class="pt-3 text-white">{{ 'offer.description' | translate }}</label>
  <div class="font-size-14 text-white">{{ currentCampaign?.PortalDescription }}</div>
</div>
